// Horario de asignacion de turnos (diferenciados por roles)

import React from 'react';
import { useUser } from '../UserContext';
import ShiftTemplateList from '../components/ShiftTemplateList';
import RegisterAttendanceForEmployee from '../components/RegisterAttendanceForEmployee';
import ShiftSchedulerTable from '../components/ShiftSchedulerTable';
import { Box, Typography } from '@mui/material';

export default function SchedulesShiftAssignment() {
  const { hasRole } = useUser();

  return (
    <section>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Horarios</Typography>
      </Box>

      {hasRole(['ADMIN', 'SUPERVISOR']) && (
        <>
          <ShiftTemplateList />
          <br />
          <ShiftSchedulerTable />
        </>
      )}
      {hasRole('EMPLOYEE') && (
        <RegisterAttendanceForEmployee />
      )}
    </section>
  );
}